var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 20.5H21.75",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 3.99998C17.6478 3.60216 18.1874 3.37866 18.75 3.37866C19.0286 3.37866 19.3044 3.43353 19.5618 3.54014C19.8192 3.64674 20.053 3.803 20.25 3.99998C20.447 4.19697 20.6032 4.43082 20.7098 4.68819C20.8165 4.94556 20.8713 5.22141 20.8713 5.49998C20.8713 5.77856 20.8165 6.05441 20.7098 6.31178C20.6032 6.56915 20.447 6.803 20.25 6.99998L7.75 19.5L3.75 20.5L4.75 16.5L17.25 3.99998Z",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.554093128f4476c52cb2b76851418175.svg";
export { ForwardRef as ReactComponent };